import { Controller } from 'stimulus';

const ADD_NEW_VENDOR_OPTION = '+new_vendor';

export default class extends Controller {
  static targets = ['select', 'accountNumber'];
  #previousValue;

  connect() {
    this.#previousValue = this.selectTarget.value;
    this.optionsObserver = new MutationObserver(() => this.#selectionChanged());
    this.optionsObserver.observe(this.selectTarget, { childList: true });
  }

  disconnect() {
    this.optionsObserver.disconnect();
  }

  change() {
    if (this.selectTarget.value !== ADD_NEW_VENDOR_OPTION) {
      this.#selectionChanged();
      return;
    }

    this.selectTarget.value = this.#previousValue;
    this.dispatch('add', { prefix: 'vendor', target: this.selectTarget });
  }

  #selectionChanged() {
    this.#previousValue = this.selectTarget.value;
    this.#updateAccountNumber();
  }

  #updateAccountNumber() {
    const selectedOption = this.selectTarget.selectedOptions[0];

    this.accountNumberTarget.value = selectedOption?.dataset.accountNumber ?? '';
  }
}
